
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefcf5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefcf5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $800sp = parcelRequire("800sp");

var $4OBpG = parcelRequire("4OBpG");
var $1245b2c715bfc127$var$_dec, $1245b2c715bfc127$var$_class, $1245b2c715bfc127$var$_JupiterTerminal;
let $1245b2c715bfc127$export$71e2073c5b7e73db = ($1245b2c715bfc127$var$_dec = (0, $4OBpG.customElement)("jupiter-terminal"), $1245b2c715bfc127$var$_dec($1245b2c715bfc127$var$_class = ($1245b2c715bfc127$var$_JupiterTerminal = class JupiterTerminal extends (0, $800sp.LitElement) {
    firstUpdated() {
        let jup = window.Jupiter;
        // Initialize the Jupiter widget
        if (jup) jup.init({
            displayMode: "widget",
            endpoint: "https://api.testnet-beta.solana.com",
            defaultExplorer: "SolanaFM",
            formProps: {
                fixedOutputMint: true,
                swapMode: "ExactIn",
                initialAmount: "100",
                initialOutputMint: "DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263"
            }
        });
    }
    render() {
        return (0, $800sp.html)`
      <div id="jupiter-terminal"></div>
    `;
    }
}, $1245b2c715bfc127$var$_JupiterTerminal.styles = (0, $800sp.css)`
    /* Add any custom styles for your web component here */
  `, $1245b2c715bfc127$var$_JupiterTerminal)) || $1245b2c715bfc127$var$_class);


//# sourceMappingURL=index.3e4b82f2.js.map
